"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuSplitGroupClassNames: ()=>menuSplitGroupClassNames,
    useMenuSplitGroupStyles_unstable: ()=>useMenuSplitGroupStyles_unstable
});
const _react = require("@griffel/react");
const menuSplitGroupClassNames = {
    root: 'fui-MenuSplitGroup'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        mc9l5x: "f22iagw",
        u7v6m2: "f168awwq",
        Bo1wru1: [
            "f1om2jlk",
            "fcyhg04"
        ],
        Bhkyaub: [
            "fgqgg70",
            "fqo1hry"
        ],
        J9ixe0: [
            "fh1zedf",
            "f1auaj6e"
        ],
        rj29m3: [
            "fokbbcd",
            "f1xlvh9o"
        ],
        B2knx3v: "f1mf2v5d",
        Bl7aesu: "fi8lk9b",
        e82tai: "f1tc32yi",
        Bnkcs84: "f1kve8m0"
    }
}, {
    d: [
        ".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}",
        ".f168awwq>.fui-MenuItem:nth-child(1){width:100%;}",
        ".f1om2jlk>.fui-MenuItem:nth-child(2){border-top-left-radius:0;}",
        ".fcyhg04>.fui-MenuItem:nth-child(2){border-top-right-radius:0;}",
        ".fgqgg70>.fui-MenuItem:nth-child(2){border-bottom-left-radius:0;}",
        ".fqo1hry>.fui-MenuItem:nth-child(2){border-bottom-right-radius:0;}",
        ".fh1zedf>.fui-MenuItem:nth-child(2){padding-left:0;}",
        ".f1auaj6e>.fui-MenuItem:nth-child(2){padding-right:0;}",
        ".fokbbcd>.fui-MenuItem:nth-child(2){margin-left:auto;}",
        ".f1xlvh9o>.fui-MenuItem:nth-child(2){margin-right:auto;}",
        ".f1mf2v5d>.fui-MenuItem:nth-child(2)::before{content:\"\";}",
        ".fi8lk9b>.fui-MenuItem:nth-child(2)::before{width:var(--strokeWidthThin);}",
        ".f1tc32yi>.fui-MenuItem:nth-child(2)::before{height:24px;}",
        ".f1kve8m0>.fui-MenuItem:nth-child(2)::before{background-color:var(--colorNeutralStroke1);}"
    ]
});
const useMenuSplitGroupStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuSplitGroupClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuSplitGroupStyles.js.map

//# sourceMappingURL=useMenuSplitGroupStyles.js.map